import i18n from '@/plugins/i18n';
import { TranslateResult } from 'vue-i18n';

type HeaderOptions = {
  text?: TranslateResult;
  value?: string;
  align?: 'start' | 'center' | 'end';
  sortable?: boolean;
  filterable?: boolean;
  groupable?: boolean;
  divider?: boolean;
  class?: string | string[];
  cellClass?: string | string[];
  width?: string | number;
  filter?: (value: any, search: string, item: any) => boolean;
  sort?: (a: any, b: any) => number;
};

export const selectionTableHeaders: HeaderOptions[] = [
  {
    align: 'start',
    sortable: false
  },
  {
    text: i18n.t('page.selection.ean'),
    value: 'ean'
  },
  {
    text: i18n.t('page.selection.reference'),
    value: 'ref'
  },
  {
    text: i18n.t('page.selection.designation'),
    value: 'designation'
  },
  {
    text: i18n.t('page.selection.beginDate'),
    value: 'beginDate'
  },
  {
    text: i18n.t('page.selection.billingUnit'),
    value: 'billingUnit'
  },
  {
    text: i18n.t('page.selection.incoterm'),
    value: 'incoTerm'
  },
  {
    text: i18n.t('page.selection.pcb'),
    value: 'pcbPackaging'
  },
  {
    text: i18n.t('page.selection.francoAmount'),
    value: 'francoAmount'
  },
  {
    text: i18n.t('page.selection.francoUnit'),
    value: 'francoUnit'
  },
  {
    text: i18n.t('page.selection.netPrice'),
    value: 'netPrice'
  }
];

export const duplicatesSelectionTableHeaders = [...selectionTableHeaders];
duplicatesSelectionTableHeaders.splice(4, 1);
duplicatesSelectionTableHeaders.splice(1, 2);
